import { render, staticRenderFns } from "./IconLifebuoy.vue?vue&type=template&id=db756e98&"
var script = {}
import style0 from "./IconLifebuoy.vue?vue&type=style&index=0&id=db756e98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports